module.exports = __webpack_public_path__ + "static/media/numerals_img.12acef83.JPG";